import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { Link } from "react-router-dom";
// import { Breakpoints } from "../../constants/CssConstants";
import { Paths, Urls } from "../../constants/UrlConstants";
import Content from "../../content/Content";
import Contentify from "../../content/Contentify";
import Store from "../../content/Store";
import { shouldShowIfAllSMEModulesDontMatch } from "../../helpers/SMEModules/smeModuleHelper";
import NotificationsStatus from "../notifications/NotificationsStatus";
import InboxStatus from "./InboxStatus";
import NewCard  from "./NewCard.js";
import EAPLapsecard  from "./EAPLapseView.js";
import LapseCard  from "./LapsedView.js";
import {
  nonClaimsModules,
  travelOrEapModules
} from "../../constants/SMEModulesToMatchOn";
// import AddAPlanLink from "../shared/AddAPlanLink";
// import UploadDocument from "../contactus/onlineLinks/UploadDocument";
// import SendAnInvoice from "../contactus/onlineLinks/SendAnInvoice";
import EAPCard from "./EAPCard.js";
import LinkAPlan from "./LinkAPlan.js";
import { SagaCard } from "./SagaCard.js" ;
import { EPDomain_ROOT } from "../../constants/EP-config";
// import HomeCarousel from "./HomeCarousel.js";
// import EPQueryParams from "../../constants/EPQueryParams";
import { Layouts } from "../../constants/Constants";
import { shouldShowIfAnySMEModulesMatch } from "./../../helpers/SMEModules/smeModuleHelper";
import { EAPEssential, EAPPremier } from "../../constants/SMEModules";

export class HomeHero extends Component {
  static content = Store.Home;
  constructor(props) {
    super(props);
    this.state = {
      urlUploadDoc:Urls.EngagementPortal[EPDomain_ROOT].uploadDoc,
      urlSendInvoice:Urls.EngagementPortal[EPDomain_ROOT].whohadtreatment
    };
  }
  GetMatchedImage(matches, imgSrcMobile, imgSrc) {
    return matches ? (
      <img src={imgSrcMobile} alt="" aria-hidden />
    ) : (
      <img src={imgSrc} alt="" aria-hidden />
    );
  }

  handleCallbackUploadDoc = (childData) => {
    this.setState({ urlUploadDoc: childData });
  };
  handleCallbackSendInvoice = (childData) => {
    this.setState({ urlSendInvoice: childData });
  };
  render() {
    return (
      <div className="home-hero" id="homeHero">
        <div className="home-hero-background">
          {/* <Content
            names={[
              Store.Home.Hero.HomeHeroBGSrc,
              Store.Home.Hero.HomeHeroBGSrcMobile
            ]}
          >
            {(homeHeroBGSrc, homeHeroBGSrcMobile) => (
              <Media query={Breakpoints.xsDown}>
                {(matches) =>
                  this.GetMatchedImage(
                    matches,
                    homeHeroBGSrcMobile,
                    homeHeroBGSrc
                  )
                }
              </Media>
            )}
          </Content> */}
        </div>
        <div className="home-hero-contents">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                {/* <h1>
                  <span className="hidden-xs-down">
                    <Content name={Store.Home.Hero.HeadingWelcome} />
                  </span>{" "}
                  <Content name={Store.Home.Hero.HeadingApp} />
                </h1> */}
                {/* <p className="last-logged-in">
                  <Content name={Store.Home.Hero.LastLoggedIn} />{" "}
                  {this.props.LastLoggedInDate}{" "}
                  <Content name={Store.Home.Common.At} />{" "}
                  {this.props.LastLoggedInTime}
                </p> */}
                <div  className = {this.props.page === 'home'?"homebox":  "box"}>
                  <div className="container">
                    {/* <div className="row"> */}
                    <div className={this.props.layout === Layouts.MOL? "row info-width" : "row info-widthHol" }  >
                      <div className="latest-updates">
                        <div className="home-hero-divider-right hidden-md-down" />
                        {/* <h2>
                          <Content name={Store.Home.Hero.LatestUpdates} /> */}
                        <h2 className="your-activity">
                          <Content name={Store.Home.Hero.YourActivity} />
                        </h2>
                        <ul className="list-unstyled latest-updates-content">                           
                          <li>
                            <InboxStatus />
                          </li>
                          {this.props.ShowRenewal && (
                            <li>
                              {/* <i className="icon-document" /> */}
                              <span className="ml-2">
                                <Content name={Store.Home.Hero.Renewal} />{" "}
                                {/* <Link to={Paths.Renewal}> */}                                
                                <Content name={Store.Home.Hero.RenewalLink} />
                                {/* </Link> */}
                              </span>
                              <br/>
                              <span className="ml-2">
                              <Link
                                to={Paths.Renewal}
                              >
                                View renewal details <span className="ml-2">➔</span>
                              </Link>
                              </span>
                            </li>
                          )}  
                          {!this.props.isFormat2 ? (
                          <li>
                            <NotificationsStatus />
                          </li>
                        ) : null}
                        </ul>
                      </div>
                      <div className={this.props.layout === Layouts.MOL ? "plan-details panelColor":"plan-details panelColorHol"}>
                        <div className="home-hero-divider-left hidden-md-down" />
                        {/* <h2 className="">
                          <PolicyDescription
                            productType={this.props.ProductType}
                            isSME={this.props.isSME}
                            policyDescription={<Content name={Store.Policy} />}
                          />
                        </h2> */}
                        {/* <ul className="list-unstyled membership-meta"> */}
                        <ul className="list-unstyled latest-updates-content">
                          <li>
                          <div className={this.props.isLapsed ? "plan-detailsContentLapsed":"plan-detailsContentMember"}>
                            <span className="label planvalue">
                              <Content
                                name={Store.Home.Hero.MembershipNumber}
                              />
                            </span>{": "}
                            <span className="label planvalue">
                              {this.props.MembershipNumber}
                            </span>
                            </div>                              
                          </li>
                          {!this.props.isLapsed && (
                            <li>
                            <div className ="plan-detailsContent">
                              <span className="label planvalue">
                                <Content name={Store.Home.Hero.RenewalDate} />
                              </span>{": "}
                              <span className="value planvalue">
                                {this.props.RenewalDate}
                              </span>
                              </div>                             
                            </li>)}
                            </ul>                        
                      </div>
                    </div>
                    <div className="row row-color">
                      <LinkAPlan/>
                    </div>
                    <div className=" row row-color px-0">
                        {this.props.shouldShowClaims  ? 
                          this.props.IsSaga ? <SagaCard/> :
                          (this.props.isLapsed && (this.props.EAPEssential || this.props.EAPPremier)) 
                          ? <EAPLapsecard/> : 
                          this.props.isLapsed ? <LapseCard/>:<NewCard/> :<EAPCard/>}
                    </div>
                    {/* <div>
                      <br/>
                    </div> */}
                    {/* <div className="row row-color">
                    {this.props.isLapsed?null:<HomeCarousel/>}
                    </div> */}
                    {/* <div className="row">
                      <div className="col-sm-4">
                        {this.props.shouldShowClaims && (
                          <div>
                            <MakeAClaimLink/> 
                          </div>
                        )}
                      </div>
                      <div className="col-sm-4">
                        {this.props.shouldShowUploadDocumentsLink && (
                          <div>
                            <EPQueryParams url={this.state.urlUploadDoc} updatedURL={this.handleCallbackUploadDoc}/>
                            <UploadDocument featureFlagEP={this.props.featureFlagEP} url={this.state.urlUploadDoc}/>
                          </div>
                        )}
                      </div>
                      <div className="col-sm-4">
                        {this.props.shouldShowClaims && (
                          <div>
                            <EPQueryParams url={this.state.urlSendInvoice} updatedURL={this.handleCallbackSendInvoice}/>
                            <SendAnInvoice featureFlagEP={this.props.featureFlagEP} url={this.state.urlSendInvoice}/>
                          </div>
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export const mapStateToHomeHero = (state) => {
  const { IsLapsed: isLapsed, IsFormat2: isFormat2, IsSME: isSME } =
    state.policyReducer.selectedPolicy || {};
  return {
    shouldShowClaims: shouldShowIfAllSMEModulesDontMatch(
      state.policyReducer && state.policyReducer.selectedPolicy,
      nonClaimsModules
    ),
    shouldShowUploadDocumentsLink: shouldShowIfAllSMEModulesDontMatch(
      state.policyReducer && state.policyReducer.selectedPolicy,
      travelOrEapModules
    ),
    isLapsed: isLapsed,
    isFormat2,
    isSME,
    featureFlagEP : state.unreadMessagesReducer.featureFlagEP,
    IsSaga : state.policyReducer.selectedPolicy.IsSaga,
    layout: state.layoutReducer && state.layoutReducer.layout,
    EAPPremier: shouldShowIfAnySMEModulesMatch(state.policyReducer && state.policyReducer.selectedPolicy, [EAPPremier]),
    EAPEssential: shouldShowIfAnySMEModulesMatch(state.policyReducer && state.policyReducer.selectedPolicy, [
      EAPEssential
    ]),
  };
};

export default withRouter(connect(mapStateToHomeHero)(Contentify(HomeHero)));
